/* istanbul ignore file */
import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { environment } from "@env";
import { HasContextGuard } from "@core/guard/has-context.guard";
import { IsAuthenticatedGuard } from "@core/guard/is-authenticated.guard";
import { ContentLayoutComponent } from "@layout/content-layout/content-layout.component";


const routes: Routes = [
  {
    path: "auth",
    loadChildren: () =>
      import("@modules/auth/auth.module").then(m => m.AuthModule)
  },
  {
    path: "context",
    canActivateChild: [
      IsAuthenticatedGuard,
    ],
    loadChildren: () =>
      import("@modules/context/context.module").then(m => m.ContextModule)
  },
  {
    path: "",
    component: ContentLayoutComponent,
    canActivateChild: [
      IsAuthenticatedGuard,
      HasContextGuard,
    ],
    children: [
      {
        // Default to the dashboard when it's just the TLD, which will then require auth/context
        path: "",
        redirectTo: "/dashboard",
        pathMatch: "full",
      },
      {
        path: "dashboard",
        loadChildren: () =>
          import("@modules/dashboard/dashboard.module").then(m => m.DashboardModule)
      },
      {
        path: "pages",
        loadChildren: () =>
          import("@modules/pages/pages.module").then(m => m.PagesModule)
      },
      {
        path: "pii-triggers",
        loadChildren: () =>
          import("@modules/pii/pii.module").then(m => m.PiiModule)
      },
      {
        path: "tags",
        loadChildren: () =>
          import("@modules/tags/tags.module").then(m => m.TagsModule)
      },
      {
        path: "error",
        loadChildren: () =>
          import("@modules/error/error.module").then(m => m.ErrorModule)
      },
      {
        path: "**",
        pathMatch: "full",
        loadChildren: () =>
          import("@modules/error/error.module").then(m => m.ErrorModule)
      }
    ]
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      enableTracing: false, // !environment.production,
      onSameUrlNavigation: "reload",
      scrollPositionRestoration: "enabled",
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
